export default __webpack_public_path__ + "static/media/pp-kayenta.dfa91c49.png";